import React from 'react';
import ChatBox from '../components/chatbot/ChatBox';
import './ChatPage.css';

const ChatPage = () => {
  return (
    <div className="chat-container">
      <ChatBox />
    </div>
  );
}


export default ChatPage;
